let LateSwap = {
    LATESWAP_SET_IS_USED: 'LATESWAP_SET_IS_USED',
    LATESWAP_SET_UPLOADED_CSV_DATA: 'LATESWAP_SET_UPLOADED_CSV_DATA',
    LATESWAP_SET_CSV_LINEUPS: 'LATESWAP_SET_CSV_LINEUPS',
    LATESWAP_SET_SIMPLEX_LINEUPS: 'LATESWAP_SET_SIMPLEX_LINEUPS',
    LATESWAP_SET_LINEUP_VIEWS: 'LATESWAP_SET_LINEUP_VIEWS',
    LATESWAP_SET_LINEUPS_USED_PLAYERS: 'LATESWAP_SET_LINEUPS_USED_PLAYERS',
    LATESWAP_SET_LOADING_STATUS: 'LATESWAP_SET_LOADING_STATUS',
    LATESWAP_SET_CREATED_LINEUPS_MAP: 'LATESWAP_SET_CREATED_LINEUPS_MAP',
    LATESWAP_GROUP_SAME_LINEUPS: 'LATESWAP_GROUP_SAME_LINEUPS',

    LATESWAP_LOADING_STATUS_NOT_STARTED: 'LATESWAP_LOADING_STATUS_NOT_STARTED',
    LATESWAP_LOADING_STATUS_IN_PROGRESS: 'LATESWAP_LOADING_STATUS_IN_PROGRESS',
    LATESWAP_LOADING_STATUS_FINISHED: 'LATESWAP_LOADING_STATUS_FINISHED',

    LATESWAP_CSV_ROW_SEPARATOR: '\n',
    LATESWAP_CSV_CELL_SEPARATOR: ',',

    LATESWAP_INCORRECT_CSV_FORMAT_MESSAGE:
        'Incorrect file format. Please ensure you have the correct CSV for Late Swap Mode.',
    LATESWAP_DUPLICATED_LINEUP_ON_PLAYER_SWAP_MESSAGE:
        'Changing this player would create a duplicate. Do you want to proceed?',
};

export default LateSwap;
